import React, {useEffect, useState} from 'react';
import RadioGroup from "b2b-ui-components-lib/lib/components/radioGroup";
import {contractOptions, serviceHardwareOptions} from "../../../home/common/constants/constants";
import ServicesDropdown from "./servicesDropdown/servicesDropdown";
import {stopBackgroundScrolling} from "../../../common/utils/app.utils";
function HardwareList(props) {
    let {commercialAttribute,setCpe,setCpeSpecification,setHardwareType,selectedHardwareType} = props;
    const clickHardwareTypeChange = (value) => {
        if(value && value.value=== 'NON_STANDARD'){
            setCpe(commercialAttribute && commercialAttribute.cpe);
            setCpeSpecification(commercialAttribute && commercialAttribute.cpeSpecification);
        }
        setHardwareType(value);
    };

    return (
        <React.Fragment>
            <div className="select_info">
                <div className="text">Hardware Type </div>
            </div>
            <div className="radio_box">
                <RadioGroup
                    options={serviceHardwareOptions}
                    value={selectedHardwareType}
                    onChange={clickHardwareTypeChange}
                />
            </div>
        </React.Fragment>

    );
}


export default HardwareList;
